import React from "react"

import { Box, Image } from "src/UILibrary"

interface Props {
  image?: string
  color?: string
  opacity: number
}
export const ThumbItem = ({ image, color, opacity }: Props) => {
  return (
    <Box sx={{ p: "0rem" }}>
      <Image
        src={image!}
        sx={{ height: 240, bgcolor: color ? color : "transparent", opacity: `${opacity}` }}
        alt=""
      />
    </Box>
  )
}
